import type { FloorDeviceType, WallMaterial } from './types'
import { OBSTACLE_PRESETS } from './obstacles'

export const WALL_MATERIALS: {
  id: WallMaterial
  label: string
  attenuationDb: number
}[] = [
  { id: 'drywall', label: 'Drywall', attenuationDb: 3 },
  { id: 'brick', label: 'Brick', attenuationDb: 6 },
  { id: 'concrete', label: 'Concrete', attenuationDb: 10 },
  { id: 'reinforced_concrete', label: 'Reinforced concrete', attenuationDb: 15 },
  { id: 'glass', label: 'Glass', attenuationDb: 2 },
  { id: 'metal', label: 'Metal', attenuationDb: 20 },
  { id: 'wood', label: 'Wood', attenuationDb: 4 },
  { id: 'custom', label: 'Custom', attenuationDb: 8 },
]

export const OBSTACLE_TYPES = OBSTACLE_PRESETS.map(({ id, label, attenuationDb, widthM, depthM, heightM }) => ({
  id,
  label,
  attenuationDb,
  widthM,
  depthM,
  heightM,
}))

export const INFRA_DEVICE_TYPES: { id: FloorDeviceType; label: string }[] = [
  { id: 'access_point', label: 'Access point' },
  { id: 'wireless_controller', label: 'Wireless controller' },
  { id: 'switch', label: 'Switch' },
  { id: 'router', label: 'Router' },
  { id: 'firewall', label: 'Firewall' },
  { id: 'camera', label: 'IP camera' },
  { id: 'sensor', label: 'Environmental sensor' },
  { id: 'ups', label: 'UPS' },
  { id: 'pdu', label: 'PDU' },
  { id: 'iot_gateway', label: 'IoT gateway' },
]

/** Default snap grid step (% of floor width/height). */
export const DEFAULT_SNAP_GRID_PCT = 1

/** Snap grid step sizes (% of floor width/height). */
export const SNAP_GRID_OPTIONS = [0.5, 1, 2, 3, 4, 5, 8, 10, 15, 20] as const

export const HEATMAP_LAYERS = [
  { id: 'rssi', label: 'RSSI' },
  { id: 'snr', label: 'SNR' },
  { id: 'quality', label: 'Coverage quality' },
  { id: 'utilization', label: 'Channel utilization' },
  { id: 'interference', label: 'Interference' },
  { id: 'clientDensity', label: 'Client density' },
] as const

export function materialAttenuation(material: WallMaterial, customDb?: number): number {
  if (material === 'custom' && customDb != null) return customDb
  return WALL_MATERIALS.find(m => m.id === material)?.attenuationDb ?? 8
}

export function deviceStatusColor(status?: string): string {
  switch (status) {
    case 'critical':
      return '#dc2626'
    case 'warning':
      return '#f59e0b'
    case 'offline':
      return '#64748b'
    case 'maintenance':
      return '#6366f1'
    default:
      return '#22c55e'
  }
}
